/**
 * The popup-to-opener message contract for the Slack OAuth flow. Sender
 * (`SlackOAuthCallback`) and listener (`useConnectSlackPopup`) both import these, so a typo
 * on either side is a compile error rather than a message nobody receives.
 */
import type { OAuthMessageTypes } from "@/shared/components/OAuthCallback/OAuthCallbackPage";

export const SLACK_OAUTH_MESSAGES = {
  success: "slack-oauth-success",
  error: "slack-oauth-error",
} as const satisfies OAuthMessageTypes;
